/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingResponseDtoPropertyCategory = typeof ListingResponseDtoPropertyCategory[keyof typeof ListingResponseDtoPropertyCategory];


export const ListingResponseDtoPropertyCategory = {
  APARTMENT: 'APARTMENT',
  HOUSE: 'HOUSE',
  RECREATIONAL: 'RECREATIONAL',
  LAND: 'LAND',
  OTHER: 'OTHER',
} as const;
